// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='4.27 2 15.41 20'
    ...attributes
  ><path
      d='M19.61 16a1.2 1.2 0 0 0-.22-.33L14.76 11a1 1 0 0 0-1.41 1.41l2.92 2.92h-7a3 3 0 0 1-3-3V3a1 1 0 1 0-2 0v9.37a5 5 0 0 0 5 5h7l-2.92 2.92a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l4.63-4.63a1 1 0 0 0 .22-.33 1 1 0 0 0 0-.75'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconTurnDownRight';
export default IconComponent;
